import { makeStyles, Theme, } from '@material-ui/core/styles';
import {cobalt, lightCobalt,} from 'styles/abstract/variables';

const baseStyle = {
    textOverflow: 'ellipsis',
    overflow: 'hidden',
};

export const makeProductsItemAttributesStyles = makeStyles((theme: Theme) => ({
    list: {
        display: 'flex',
        flexFlow: 'row',
        flexWrap: 'wrap',
        overflow: 'visible',
    },

    name: {
        flexBasis: '19%',
        textAlign: 'right',
        ...baseStyle,
        ...theme.typography.caption,

        '&::after': {
            content: "':'",
        },

        [theme.breakpoints.down('md')]: {
            flexBasis: '22%',
        },
    },

    value: {
        flexBasis: '79%',
        marginLeft: 'auto',
        textAlign: 'left',
        ...baseStyle,
        ...theme.typography.caption,

        [theme.breakpoints.down('md')]: {
            flexBasis: '76%',
        },
    }
}));

export const makeProductsItemLabelStyles = makeStyles((theme: Theme) => ({
    root: {
        ...theme.typography.h6,
        lineHeight:1.2,

        [theme.breakpoints.down('md')]: {
            fontSize: '1rem',
        },
    }
}));

export const makeProductsItemButtonStyles = makeStyles((theme: Theme) => ({
    root: {
        [theme.breakpoints.only('md')]: {
            marginTop: theme.spacing(2),
        },
    }
}), { index: 1, });

export const makeShortDescriptionStyles = makeStyles((theme: Theme) => ({
    root: {
        '& a': {
            color: cobalt,
            textDecoration: 'none',

            '&:hover': {
                color: lightCobalt,
            }
        },
    },
}))
